import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext'; 
import cirrusLogoLight from '../assets/cirrus-logo-dark.png';
import cirrusLogoDark from '../assets/cirrus-logo-white.png';

const Sidebar = ({ isCollapsed, toggleCollapse }) => {
  const { theme, toggleTheme } = useTheme(); 

  const NavItem = ({ to, icon, text }) => (
    <NavLink 
      to={to} 
      className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}
    >
      <span className="nav-icon">{icon}</span>
      <span className="nav-text">{text}</span>
    </NavLink>
  );

  return (
    <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        {/* <div className="salesforce-logo"></div> */}
        {/* <span className="nav-text">DREAMFORCE <br /> SAN FRANCISCO</span> */}
        <img 
          src={theme === 'dark' ? cirrusLogoDark : cirrusLogoLight} 
          alt="Cirrus Logo" 
          className="cirrus-logo-img" 
        />
      </div>

      <nav className="sidebar-nav">
        {/* <NavItem to="/dashboard" icon="🏠" text="Dashboard" /> */}
        <NavItem to="/salescloud" icon="☁️" text="Sales Cloud" />
        <NavItem to="/playground" icon="🧪" text="Playground" />
        <NavItem to="/auth-flow" icon="🔑" text="Auth Flow" />

      </nav>

      <div className="sidebar-footer">
        <div className="user-profile">
          <div className="user-avatar"></div>
          <span className="nav-text">Matt Brewer</span>
        </div>
        
        <div className="footer-actions">
          <button onClick={toggleTheme} className="theme-toggle-button" title="Toggle Theme">
            {theme === 'dark' ? '☀️' : '🌙'}
          </button>
          <button onClick={toggleCollapse} className="collapse-toggle-button" title="Toggle Sidebar">
            {isCollapsed ? '→' : '←'}
          </button>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
